import { lazy, Suspense, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { ContentContext } from '@parcel2go/npm-p2g-app';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';
import { SettingsCache } from '~/lib/consts/settings-cache';

const PriceMatrix = lazy(() => import('~/apps/smartsend/components/pricematrix/PriceMatrix'));
const RatesMatrix = lazy(() => import('~/apps/smartsend/components/pricematrix/RatesMatrix.tsx'));

export default function Component() {
  const { track } = useSmartSendAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const showSidepanelRates = SettingsCache.settings.Features.includes('RatesSidepanel');

  useOnLoad(() => {
    const title = t('POSTAGE_RATES_PAGE_TITLE', { defaultValue: 'Postage Rates' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.SMARTSEND });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.Pricing }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.Pricing
      }
    });
  });

  return (
    <Tagged tag="screen-price-matrix">
      <Suspense>{showSidepanelRates ? <RatesMatrix /> : <PriceMatrix />}</Suspense>
    </Tagged>
  );
}

Component.displayName = 'SmartSend: Postage Rates';
